console.log('js/packages.js -> v0.1.0');

$(function() {
	// select the package if the url contains the package_id
	const package = getQueryStringParameterByName(window.location.href, 'package_id');

	// check if the query parameter is in the url
	if (package !== null) {
		selectPackage(package);
	}

	function selectPackage(package) {
		const packageOption = document.querySelector(`input[package="${package}"]`);

		// if the value is not null it means there is a package with that package id on the page
		// otherwise we don't want to try and select anything
		if (packageOption !== null) {
			packageOption.checked = true;
		}
	}

	var $inputRadioChecked = $(".pck-selected-style .package-option input[type=radio].package-selection-item");
	var $inputDatesRadioChecked = $(".dates-selected-style .listing_query_arrival_date input[type=radio].radio_buttons");

	$(".pck-selected-style .package-option input[type=radio].package-selection-item:checked").parents('label.radio').addClass('selected');
	$(".dates-selected-style .listing_query_arrival_date input[type=radio].radio_buttons:checked").parents('label.radio').addClass('selected');

  	$inputRadioChecked.change(function() {

		if ($(this).attr('data-id') == "0") {
			$('#reservation-query-submit').hide();
			$('.listing-query-box').removeClass('add-ticker');
		}
		else {
			$('#reservation-query-submit').show();
		};

		var checked = this;

    	$inputRadioChecked.each( function(event) {
      		if(this !== checked) {
        		$(this).closest("label").removeClass("selected");
      		}
		});

		let listingCallToActionContainer = document.querySelector('.listing-primary-cta-box');

    	$(this).closest("label").addClass("selected");

		if ($(this).hasClass('instant')) {
			listingCallToActionContainer.classList.add('instant-package-selected');
		}
		else {
			listingCallToActionContainer.classList.remove('instant-package-selected');
		}

    	receipt_update();
  	});

	$inputDatesRadioChecked.change(function() {
		var checked = this;

		$inputDatesRadioChecked.each( function() {
			if (this !== checked) {
				$(this).closest("label").removeClass("selected");
			}
		});

		$(this).closest("label").addClass("selected");
	});


	// check if, on page load, an instant booking is selected, if that is the case, this should reflect in the buttons being shown.
	const hasInstantBookingPackages = document.querySelector('.has-instant-booking-packages');

	if (hasInstantBookingPackages != null) {
		setCallToActionContainer();
	}

	function setCallToActionContainer() {
		const CTAContainer = document.querySelector('.listing-primary-cta-box');

		// check if the currently selected package is an instant booking package
		const instantBookablePackage = document.querySelector('.package-selection-item.instant:checked');

		if (instantBookablePackage != null) {
			CTAContainer.classList.add('instant-package-selected');
		}
	}

});
